import React, { FC, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { Spin } from "antd";
import moment from "moment";

import ChartRangeSelector from "./ChartRangeSelector";

import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import HighChartsService from "../../services/highcharts.service";
import { PeriodIndexTypes, PeriodTypesArray } from "../../services/enums";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { IResultResponse } from "../../models/response/result.model";
import { ICryptoIndexPeriodPLChart } from "../../models/cryptoindex-periodpl-chart.model";

const PeriodPL: FC = () => {
  const [periodIndex, setPeriodIndex] = useState(PeriodIndexTypes["1m"]);

  const indexId = useTypedSelector(({ ci }) => ci.indexId);

  const { fetchedData, loading } = useHttpGet<
    IResultResponse<ICryptoIndexPeriodPLChart[]>
  >(
    `${APIRoutes.CRYPTO_INDEX_PERIOD_PL_CHART}/${indexId}/${PeriodTypesArray[periodIndex]}`,
    {
      dependencies: [periodIndex, indexId],
      condition: !!indexId,
    }
  );

  const getOptions = (data: ICryptoIndexPeriodPLChart[]) => {
    return {
      ...HighChartsService.baseSettings({
        chart: {
          type: "column",
        },
        plotOptions: {
          series: {
            negativeColor: "#ce3e3e",
          },
        },
        series: [
          {
            name: "Profit/Loss",
            data: CommonService.sortByDate(data).map(
              (el: ICryptoIndexPeriodPLChart) => [
                moment(el?.date).unix() * 1000,
                el?.value,
              ]
            ),
          },
        ],
      }),
    };
  };

  return (
    <Spin spinning={loading}>
      <ChartRangeSelector
        periodIndex={periodIndex}
        setPeriodIndex={setPeriodIndex}
      />
      <HighchartsReact
        constructorType={"stockChart"}
        highcharts={Highcharts}
        options={getOptions(fetchedData?.result)}
      />
    </Spin>
  );
};

export default PeriodPL;
